"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Categories = _interopRequireDefault(require("ContentUtils/constants/Categories"));

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _DraftSunsetPopover = _interopRequireDefault(require("./DraftSunsetPopover"));

var TAB_IDS_TO_EDITOR_ROUTES = new _immutable.OrderedMap({
  draft: 'draft',
  edit: 'content',
  settings: 'settings',
  publish: 'publishing'
});

function getEditorTabUrl(blogPostId, tabId) {
  var baseUrl = _Routes.default.edit(blogPostId, _Categories.default.blog_post.field_name);

  return baseUrl + "/" + TAB_IDS_TO_EDITOR_ROUTES.get(tabId);
}

var _default = (0, _createReactClass.default)({
  displayName: "NavTabs",
  propTypes: {
    blogPostId: _propTypes.default.number,
    showReadOnlyMode: _propTypes.default.bool.isRequired,
    userId: _propTypes.default.number,
    userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
  },
  formatMessage: function formatMessage(key) {
    return _react.default.createElement(_FormattedMessage.default, {
      message: "ComposeUI.header.tabs." + key
    });
  },
  renderUITab: function renderUITab(tabId) {
    var _this$props = this.props,
        blogPostId = _this$props.blogPostId,
        showReadOnlyMode = _this$props.showReadOnlyMode,
        userId = _this$props.userId,
        userSettings = _this$props.userSettings;
    var draftTabTitle = this.formatMessage('draft.title');
    var disabled = tabId !== 'draft' && !showReadOnlyMode;
    var href = tabId === 'draft' || !showReadOnlyMode ? null : getEditorTabUrl(blogPostId, tabId);
    var tooltip = tabId === 'draft' || showReadOnlyMode ? null : this.formatMessage('tooltip');
    var title = tabId === 'draft' ? draftTabTitle : this.formatMessage(tabId + ".title");

    var renderedTab = _react.default.createElement(_UITab.default, {
      disabled: disabled,
      href: href,
      key: tabId,
      tabId: tabId,
      title: title,
      tooltip: tooltip
    });

    return tabId === 'draft' ? _react.default.createElement(_DraftSunsetPopover.default, {
      renderedTab: renderedTab,
      userId: userId,
      userSettings: userSettings
    }) : renderedTab;
  },
  render: function render() {
    return _react.default.createElement(_UITabs.default, {
      "data-test-id": "nav-tabs",
      className: "nav-tabs",
      selected: "draft"
    }, TAB_IDS_TO_EDITOR_ROUTES.keySeq().map(this.renderUITab));
  }
});

exports.default = _default;
module.exports = exports.default;